import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import styled from 'styled-components';
import tw from 'twin.macro';

import { MenuButton } from './Button';
import { CheckboxItem } from './CheckboxItem';
import { Item, LinkItem } from './Item';
import { Popover } from './Popover';
import { SubMenuButton } from './SubMenu/Button';
import { SubPopover } from './SubMenu/Popover';

const Menu = DropdownMenuPrimitive.Root;
const SubMenu = DropdownMenuPrimitive.Sub;

const Separator = styled(DropdownMenuPrimitive.Separator)`
  ${tw`h-px bg-gray-300 w-4/5 self-center my-2`}
`;

export {
  Menu,
  MenuButton as NeedlMenuButton,
  Separator as NeedlMenuDivide,
  Item as NeedlMenuItem,
  LinkItem as NeedlMenuLink,
  SubMenu as NeedlSubMenu,
  CheckboxItem as NeedlMenuCheckboxItem,
  Popover as NeedlMenuPopover,
  SubMenuButton as NeedlSubMenuButton,
  SubPopover as NeedlSubMenuPopover,
};
